import { render, staticRenderFns } from "./MobileUnderFooter.vue?vue&type=template&id=746ee41d"
import script from "./MobileUnderFooter.vue?vue&type=script&lang=js"
export * from "./MobileUnderFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileUnderFooter.vue?vue&type=style&index=0&id=746ee41d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports